import { ideApi, workspaceApi } from '@/api/ideApi'
import { useIdeStore } from '@/store/ideStore'

export const workspaceService = {
  async openLocalProject() {
    const project = await workspaceApi.openProjectDirectory()
    if (!project) {
      return null
    }
    useIdeStore.getState().setProject(project)
    return project
  },

  async createLocalProject({ name, visibility = 'public', syncWithBackend = true }) {
    const project = await workspaceApi.createProjectDirectory({ name })
    if (!project) {
      return null
    }

    let syncError = null
    if (syncWithBackend) {
      try {
        await ideApi.createProject({
          name,
          visibility,
        })
      } catch (error) {
        // Keep local creation usable even when backend is temporarily unavailable.
        syncError = String(error?.message || 'Unable to sync project with backend.')
      }
    }

    useIdeStore.getState().setProject(project)
    return { ...project, syncError }
  },

  async openFile(node) {
    const file = await workspaceApi.readFile({ filePath: node.path })
    useIdeStore.getState().openFile({
      name: node.name,
      path: file.filePath,
      contents: file.contents,
      dirty: false,
    })
    return file
  },

  async saveActiveFile() {
    const state = useIdeStore.getState()
    const activeFile = state.openFiles.find(file => file.path === state.activeFilePath)
    if (!activeFile) {
      return null
    }

    await workspaceApi.saveFile({
      filePath: activeFile.path,
      contents: activeFile.contents,
    })
    state.markFileSaved(activeFile.path)
    return activeFile
  },
}
